var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.products),function(product,index){return _c('div',{key:index,class:[
      index == 0 ? 'pt-0' : 'pt-3',
      index + 1 === _vm.products.length ? 'pb-0' : 'pb-3',
    ]},[_c('ProductCard',{attrs:{"product":product,"rut":_vm.rut},on:{"click-detail":function($event){return _vm.$emit('see-more', $event)},"renew":function($event){return _vm.$emit('renew', $event)},"cancel-sale":function($event){return _vm.$emit('cancel-sale', $event)}}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }